// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__D6jT1","tab":"ProcedureTabs_tab__EOLxq"};